import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { SDKProvider } from '@tma.js/sdk-react'
import App from './App.tsx'
import { store } from './app/store/store.ts'
import './index.css'
// import {initMockTelegramEnv} from "./mockTelegramEnv.ts";
//
// initMockTelegramEnv()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SDKProvider acceptCustomStyles debug>
      <Provider store={store}>
        <App />
      </Provider>
    </SDKProvider>
  </React.StrictMode>,
)
